/* eslint-disable no-restricted-globals */

import { GDPR_REGIONS } from './regions';

let location = {};

try {
  location = window.location;
} catch (e) {
  location = self.location;
}
export const BASE_URL = `${location.protocol}//${location.host}`;
export const API_V1 = '/api/v1';
export const API_BASE_URL = `${BASE_URL}${API_V1}`;

export const ALERT_SERVICE = '/alert';

// IOC NEW
export const IOC_INTEL_CARD_SERVICE = '/ioc-intel/card-api/v1';
export const IOC_INTEL_CARD_PATHS = {
  RETRIEVE: `${IOC_INTEL_CARD_SERVICE}/ioc-card/retrieve`,
  AI_SUMMARY: `${IOC_INTEL_CARD_SERVICE}/ioc-card/summarize`
};

export const IOC_INTEL_DASHBOARD_SERVICE = '/ioc-intel/dashboard-api';
export const IOC_INTEL_DASHBOARD_PATHS = {
  OVERVIEW: `${IOC_INTEL_DASHBOARD_SERVICE}/v1/dashboard/overview`,
  SAMPLES_CSV: `${IOC_INTEL_DASHBOARD_SERVICE}/v1/dashboard/samples.csv`
};

export const IOC_INTEL_ENRICHMENT_API_SERVICE = '/ioc-intel/enrichment-api/v1';
export const IOC_INTEL_ENRICHMENT_API_PATHS = {
  USAGE: `${IOC_INTEL_ENRICHMENT_API_SERVICE}/enrichment/usage`
};

export const IOC_INTEL_FEED_SERVICE = '/ioc-intel/feed-api/v1';
export const IOC_INTEL_FEED_PATHS = {
  OBSERVATIONS: `${IOC_INTEL_FEED_SERVICE}/feed/observations`
};

const USER = '/user';
export const USER_API_PATHS = {
  LIST: `${USER}`,
  UPDATE: `${USER}/update`,
  USER_CONFIGURATION: `${USER}/configuration`,
  NOTIFICATIONS: `${USER}/notifications`
};

export const USER_CONFIGURATION_BASE_URL = `${BASE_URL}${USER_API_PATHS.USER_CONFIGURATION}`;
export const USER_API_BASE_URL = `${BASE_URL}${USER}`;
export const USER_CONFIGURATION = USER_API_PATHS.USER_CONFIGURATION;
export const USER_NOTIFICATIONS = USER_API_PATHS.NOTIFICATIONS;

export const CUSTOMER_CONFIGURATION_BASE_URL = `${BASE_URL}/customer/configuration`;
export const USER_CONFIGURATION_UPSERT = `/upsert`;

export const CUSTOMER_CONFIGURATION_CREATE = `/create`;
export const CUSTOMER_CONFIGURATION_DELETE = `/delete`;

export const CUSTOMER_CONFIGURATION_UPDATE = '/update';

export const KIBANA_LOG = `${API_BASE_URL}/log`;

export const ATTACHMENT_URL = `${API_BASE_URL}/entity/file`;

export const PENDING = 'PENDING';
export const ERROR = 'ERROR';
export const SUCCESS = 'SUCCESS';

// ASM API CONSTS

const MDF = '/mdf';
const ISSUES = `${MDF}/issues`;
const ASM_JOB_STATUS = `${MDF}/status`;
const ASSETS = `${MDF}/assets`;
const EXPORT_ASSETS_URL = `${ASSETS}/export`;
const ASSET_TYPES = `${ASSETS}/types`;
const ASSETS_STATUS = `${ASSETS}/status`;
const ASSETS_BULK_STATUS = `${ASSETS}/bulk_update`;
const ASSETS_ATTRIBUTE_IDS_UPDATE = `${ASSETS}/bulk_update_attribute_ids`;
const ASSETS_CASCADE_ATTRIBUTE_IDS = `${ASSETS}/cascade_attribute_ids`;
const ASSETS_MONITOR_TI = `${ASSETS}/monitor_in_ti`;
const ASSETS_COUNT = `${ASSETS}/assets_count`;
const ASSETS_COUNT_BY_FIELD = `${ASSETS}/count_by_fields`;
const ASSETS_RELATED_ALERTS = `${ASSETS}/get_related_alerts`;
const ADD_ASSET = `${ASSETS}/manual`;
const SCORES_STATISTICS = `${MDF}/scores/latest`;
const START_ASM_JOB = `${MDF}/discoveries/jobs/start`;
const ABORT_ASM_JOB = `${MDF}/discoveries/jobs/abort`;
const DISCOVERIES_JOBS = `${MDF}/discoveries/jobs`;
const DOWNLOAD_CSV_URL = `${MDF}/validation_reports/export`;
const VALIDATION_SUMMARY = `${MDF}/validation_reports/summary`;
const CUSTOMER_CONFIGURATION = `${MDF}/customers`;
const RESET_DISCOVERY = `${CUSTOMER_CONFIGURATION}/customer/reset`;
const DOWNLOAD_ASM_REPORT = `${MDF}/reports/generate`;
const ASM_ASSETS_LIMIT_COUNT = `${ASSETS}/count`;
const ASM_CERTIFICATES = `${MDF}/certificates`;
const CERTIFICATES_SUMMARY = `${MDF}/certificates/summary`;

// TI API CONSTS
const TI_ASSETS_LIMIT_COUNT = `/entity/count`;
const TI_ASSETS = '/entity';
export const ASM_API_PATHS = {
  ASM_JOB_STATUS,
  ASSETS,
  EXPORT_ASSETS_URL,
  ASSET_TYPES,
  ASSETS_STATUS,
  ASSETS_BULK_STATUS,
  ASSETS_MONITOR_TI,
  ASSETS_COUNT,
  ASSETS_COUNT_BY_FIELD,
  ASSETS_RELATED_ALERTS,
  ADD_ASSET,
  SCORES_STATISTICS,
  START_ASM_JOB,
  ABORT_ASM_JOB,
  DOWNLOAD_CSV_URL,
  DOWNLOAD_ASM_REPORT,
  VALIDATION_SUMMARY,
  CUSTOMER_CONFIGURATION,
  RESET_DISCOVERY,
  ASM_ASSETS_LIMIT_COUNT,
  ASM_CERTIFICATES,
  TI_ASSETS_LIMIT_COUNT,
  TI_ASSETS,
  CERTIFICATES_SUMMARY,
  ISSUES,
  ASSETS_ATTRIBUTE_IDS_UPDATE,
  ASSETS_CASCADE_ATTRIBUTE_IDS,
  DISCOVERIES_JOBS
};

export const INDICATOR = '/indicator';

const ASSET_CONFIG = '/asset-configuration';
const JOB = `${ASSET_CONFIG}/job`;
const ABORT_JOB = `${ASSET_CONFIG}/job/abort`;
const UPDATE_PREFERENCES = `${ASSET_CONFIG}/attributes/update_preferences`;

export const ASSET_CONFIG_API_PATHS = {
  ASSET_CONFIG,
  JOB,
  ABORT_JOB,
  UPDATE_PREFERENCES
};

const CUSTOMER_USAGE = '/customer-usage';
const PRICING = `${CUSTOMER_USAGE}/pricing`;
const CREDITS = `${PRICING}/credits`;
const LICENSE_USAGE = `${CUSTOMER_USAGE}/usage/licenses`;
const COINS_USAGE = `${CUSTOMER_USAGE}/usage/coins`;
const CREDITS_USAGE = `${CUSTOMER_USAGE}/usage/credits`;
const REPORTS_USAGE = `${CUSTOMER_USAGE}/usage/report-tenants`;

export const CUSTOMER_USAGE_API_PATHS = {
  CUSTOMER_USAGE,
  LICENSE_USAGE,
  COINS_USAGE,
  CREDITS_USAGE,
  PRICING,
  CREDITS,
  REPORTS_USAGE
};

const INVESTIGATIONS = '/investigation/investigations';

export const INVESTIGATIONS_API_PATHS = {
  LIST: INVESTIGATIONS,
  CREATE: `${INVESTIGATIONS}/new`,
  SCHEMA: `/investigation/schema/fields`,
  DEFAULTS: `/investigation/schema/default-hours`
};

const LEAKED_CREDENTIALS = '/compromised_credentials';

export const LEAKED_CREDENTIALS_API_PATHS = {
  LIST: `${LEAKED_CREDENTIALS}`,
  EXPORT: `${LEAKED_CREDENTIALS}/bulk/export`,
  UPDATE: `${LEAKED_CREDENTIALS}/bulk/update`
};

const AUDIT_LOG = '/audit-log';

export const AUDIT_LOG_API_PATHS = {
  LIST: `${AUDIT_LOG}/events`
};

const TE = '/threat-emulation';
export const TE_API_PATHS = {
  LIST: `${TE}/entries`,
  DOWNLOAD: `${TE}/download`,
  UPLOAD: `${TE}/upload`,
  UPLOAD_URL: `${TE}/upload-url`,
  SAMPLE_MULTIPLE: `${TE}/sample`,
  ENTRY: id => `${TE}/entries/${id}`,
  SAMPLE: id => `${TE}/entries/${id}/sample`,
  DOWNLOAD_BY_ID: id => `${TE}/entries/${id}/download`,
  GENERATE: id => `${TE}/entries/${id}/generate`
};

const AR = '/reverse-file';
export const AR_API_PATHS = {
  UPLOAD: `${AR}/upload`,
  LIST: `${AR}/entries`,
  ENTRY: sha256 => `${AR}/entries/${sha256}`
};

export const TEM_SERVICE = '/tem';
const AM_I_PROT = '/am-i-protected/api';
const IOC = '/ioc/api';
const INSIGHT = '/insight-service/api';
const CONNECTOR_FIREWALL = '/connector-firewall';
export const TEM_API_PATHS = {
  CVE_SEARCH: `${AM_I_PROT}/cve-assessment/search`,
  INSIGHT_SEARCH: `${INSIGHT}/insight/search`,
  CVE_AGGREGATED: `${AM_I_PROT}/cve-vulnerable-hosts/count-by-protection-status`,
  CVE_VULNERABLE_HOSTS_SEARCH: `${AM_I_PROT}/cve-vulnerable-hosts/search`,
  IOC_INDICATORS: `${IOC}/v2/indicators`,
  ADD_TO_BLOCK_INDICATORS: `${IOC}/v2/indicators/add-multiple`,
  GET_CUSTOMER_SUPPORTED_IOC_TYPES: `${IOC}/indicators/get-supported-integrations`,
  ATTACK_MAP_AGGREGATED: `${IOC}/attack-map/aggregated`,
  CVE_IPS_ACTIVITY_BY_CVE: `${CONNECTOR_FIREWALL}/security_logs/aggregated/cve_ips_activity_by_cve`,
  CVE_IPS_ACTIVITY_OVER_TIME: `${CONNECTOR_FIREWALL}/security_logs/aggregated/cve_ips_activity_over_time`
};

const ALERTS = '/alerts';
export const ALERT_API_PATHS = {
  LIST: `${ALERTS}`,
  BY_ID: (id = '') => `${ALERTS}/${id}`,
  BY_REF_ID: (id = '') => `${ALERTS}/ref_id/${id}`,
  RELATED_ALERTS_FOR_INDICATORS: `${ALERTS}/links/indicators`,
  ATTACHMENTS: `${ALERTS}/attachments`,
  ANALYSIS_REPORT: `${ALERTS}/analysis_report`,
  AI_SUMMARY: `${ALERTS}/summarize`,
  MITRE: `${ALERTS}/mitre`,
  PUBLISH: `${ALERTS}/publish`,
  VALUES: `${ALERTS}/values`,
  SHARE: `${ALERTS}/share`,
  COMMENT_DELETE: `${ALERTS}/comments/delete`,
  COMMENT_CREATE: `${ALERTS}/comments/create`,
  COMMENT_EDIT: `${ALERTS}/comments/update`,
  EXPORT: ({ alertId, customerId }) => `${ALERTS}/${alertId}/export?customer_id=${customerId}`,
  POPULAR_TAGS: `${ALERTS}/tags/recent`
};
export const CREDENTIALS = {
  PURCHASE: '/credentials_purchase',
  CREATE_PURCHASE: (id = '') => `/credentials_purchase/${id}/create`
};

export const TAKEDOWN = {
  REQUEST: '/takedown/request',
  SUBMIT: '/takedown/request/submit'
};

export const ALERTS_CLOSURE = `${ALERTS}/closure`;
export const ALERT_CLOSURE_API_PATHS = {
  ALERTS_CLOSURE_NOTIFY_FP: `${ALERTS_CLOSURE}/notify-false-positive`,
  ALERTS_CLOSURE_NOTIFY_SUPPRESS: `${ALERTS_CLOSURE}/notify-suppress-alert`,
  ALERTS_CLOSURE_SUPPRESS: `${ALERTS_CLOSURE}/suppress-alert`,
  ALERTS_CLOSURE_DISABLE: `${ALERTS_CLOSURE}/disable-asset`,
  ALERTS_CLOSURE_DISABLE_NOTIFY: `${ALERTS_CLOSURE}/notify-disable-asset`
};

const REPORTS = '/report-collaboration';

export const REPORT_API_PATHS = {
  LIST: `${REPORTS}/reports`,
  DOWNLOAD: `${REPORTS}/download`,
  THUMBNAIL: `${REPORTS}/thumbnail`,
  COUNT: `${REPORTS}/reports/count`
};

// KNOWLEDGEBASE
export const KNOWLEDGEBASE_SERVICE = 'knowledgebase';
export const KNOWLEDGEBASE_METADATA_SERCTORS = 'metadata/sectors';

const INCIDENTS = `/${KNOWLEDGEBASE_SERVICE}/incidents`;
const NON_TARGETED_ALERTS = `/${KNOWLEDGEBASE_SERVICE}/non-targeted-alerts`;
const NEWS = `/${KNOWLEDGEBASE_SERVICE}/news`;

export const INCIDENTS_API_PATHS = {
  LIST: INCIDENTS,
  INCIDENT: id => `${INCIDENTS}/${id}`,
  COUNT: `${INCIDENTS}/count`
};

export const NON_TARGETED_ALERTS_API_PATHS = {
  LIST: NON_TARGETED_ALERTS,
  STATUS: (customerId, referenceId) => `${NON_TARGETED_ALERTS}/${customerId}/alerts/${referenceId}/status`,
  UNREAD_COUNT: customerId => `${NON_TARGETED_ALERTS}/${customerId}/unread-count`
};

export const NEWS_API_PATHS = {
  NEWS_ITEM: id => `${NEWS}/${id}`
};

const KNOWLEDGEBASE_TL_AI_REPORTS = `/${KNOWLEDGEBASE_SERVICE}/tl-ai-reports`;
const KNOWLEDGEBASE_BRIEFS = `/${KNOWLEDGEBASE_SERVICE}/briefs`;

export const TI_BRIEF_API_PATHS = {
  GENERATE: `${KNOWLEDGEBASE_BRIEFS}/generate`
};

// AI Reports Service
export const AI_REPORTS = '/ai-reports';
export const TL_AI_REPORT = `${AI_REPORTS}/threat-landscape-report`;

export const TL_AI_REPORTS_API_PATHS = {
  TL_AI_REPORT: id => `${KNOWLEDGEBASE_TL_AI_REPORTS}/${id}`,
  DOWNLOAD_URL: `${TL_AI_REPORT}/download-url`
};

const CUSTOMER_SERVICE = '/customer';

const CAMPAIGNS = `/${KNOWLEDGEBASE_SERVICE}/campaigns`;

export const CAMPAIGNS_API_PATHS = {
  LIST: CAMPAIGNS,
  CAMPAIGN: id => `${CAMPAIGNS}/${id}`,
  CAMPAIGN_ATTACKS: id => `${CAMPAIGNS}/${id}/attacks`
};

// CUSTOMERS
export const CUSTOMERS_API_PATHS = {
  DISABLE: `${API_V1}/customer/remove`,
  UNLINK: `${API_V1}/customer/unlink`,
  UNLINK_PARTNER_PROVISIONING: `${CUSTOMER_SERVICE}/var/tenant/unlink`,
  RESTORE: `${API_V1}/customer/restore`,
  RESTORE_MSSP_PARENT_ALLOCATION: `${CUSTOMER_SERVICE}/mssp/tenant/restore`,
  CONVERT_TO_INHERITED: `${CUSTOMER_SERVICE}/mssp/tenant/convert-to-inherited`,
  DISABLE_MULTI_TENANT_CHILD: `${CUSTOMER_SERVICE}/multi-tenant/disable`,
  RESTORE_MULTI_TENANT_CHILD: `${CUSTOMER_SERVICE}/multi-tenant/restore`,
  UNLINK_MULTI_TENANT_CHILD: `${CUSTOMER_SERVICE}/multi-tenant/unlink`,
  DETACH: `${API_V1}/customer/detach_customer_from_parent`,
  AVAILABILITY: `${API_V1}${CUSTOMER_SERVICE}/availability`,
  DEFAULT_FEATURES: `${CUSTOMER_SERVICE}/customer/default-features`
};

// AEV
const AEV = '/aev';

export const AEV_API_PATHS = {
  LIST_EXPLOITABILITIES: `${AEV}/customer/exploitabilities`,
  EXPLOITABILITIES_SUMMARY: `${AEV}/customer/exploitabilities/summary`,
  CLEAN_TEMPLATES: `${AEV}/customer/exploitabilities/clean-templates`,
  EXPORT_CUSTOMER_EXPLOITABILITIES: `${AEV}/customer/exploitabilities/csv`,
  AEV_STATS: `${AEV}/asset/stats`,
  AGENTIC_AEV_DOWNLOAD: customerId => `${AEV}/agentic/${customerId}/download`,
  AGENTIC_AEV_DOWNLOAD_ALL: customerId => `${AEV}/agentic/${customerId}/download-all`,
  AGENTIC_AEV_SUMMARY: customerId => `${AEV}/agentic/${customerId}/summary`,
  AGENTIC_AEV_DOWNLOAD_OPEN_ALERT_REPORT: customerId => `${AEV}/agentic/${customerId}/download-open-alert-report`,
  AGENTIC_AEV_DOWNLOAD_REPORT_BUNDLE: customerId => `${AEV}/agentic/${customerId}/download-report-bundle`,
  AGENTIC_AEV_DOWNLOAD_OPEN_ALERT_REPORT_BUNDLE: customerId =>
    `${AEV}/agentic/${customerId}/download-open-alert-report-bundle`,
  AGENTIC_AEV_MANUAL_COOLDOWN: customerId => `${AEV}/agentic/${customerId}/manual-cooldown`,
  AGENTIC_AEV_DEEPDIVE_EMBED: `${AEV}/agentic/deepdive-embed`,
  AGENTIC_AEV_DEEPDIVE_PDF: `${AEV}/agentic/deepdive-pdf`,
  AGENTIC_AEV_BASELINE: customerId => `${AEV}/agentic/${customerId}/baseline`
};

// SOCIAL MEDIA FAKE PAGES
export const SMFP_SERVICE = '/social-pages';
const FOUND_PAGES = '/pages';

export const SMFP_API_PATHS = {
  FOUND_PAGES: `${FOUND_PAGES}`
};

// LOOKALIKE DOMAIN (Phishint)
export const LOOKALIKE_DOMAIN_SERVICE = '/phishint';

// THREAT INTEL PLATFORM (IOC Management)
export const TIP_SERVICE = '/threat-intel-platform/platform-api/api/v1';
export const TIP_PULL_SERVICE = '/threat-intel-platform/pull-api';

// Authentication
export const AUTHENTICATION = `api/v1/authentication`;
export const AUTH_CALLBACK = `authentication/callback`;
export const AUTH_TOKEN_REFRESH = `${AUTHENTICATION}/token/refresh`;

// IOC Single
export const IOC_DATA = `/ioc/api/v1`;

// CVE Single
export const CVE_DETAILS_DATA = `/cve-intel/get_enriched_cve`;

// Malwares
export const MALWARE_DETAILS_DATA = `/knowledgebase/malwares`;

// Threat Actors
export const THREAT_ACTORS = '/knowledgebase/threat_actors';

export const IOCS = `/${KNOWLEDGEBASE_SERVICE}/iocs`;

// AI Reports Service
export const TL_AI_REPORT_SUGGESTED_SCOPES = `${TL_AI_REPORT}/extended-scopes`;

// FES
const NOTIFICATIONS = '/notifications';
export const LITMOS_REGISTRATION_NOTIFICATION = `${NOTIFICATIONS}/litmos-registration`;

export const REGION_BASED_ATTACHMENT_URLS = {
  [GDPR_REGIONS.EU]: `${BASE_URL}/eu/${API_V1}/entity/file`,
  [GDPR_REGIONS.AU]: `${BASE_URL}/au/${API_V1}/entity/file`,
  [GDPR_REGIONS.US]: `${BASE_URL}/us/${API_V1}/entity/file`
};
